module.exports = require("firebaseui-vi");